module.exports = __webpack_public_path__ + "static/img/lead.9e6814e9.svg";